import React, { createContext, useContext, useState, useCallback } from 'react';
import Dl from '../components/DwM';
const DialogContext = createContext();
export const uD = () => useContext(DialogContext);
export const Dp = ({ children }) => {
  const [dOs, setDOs] = useState(null);
  const [resolver, setResolver] = useState(null);

  const mG = useCallback((options) => {
    setDOs(options);
    return new Promise((resolve) => {
      setResolver(() => resolve); 
    });
  }, []);

  const hc = () => {
    setDOs(null);
    resolver?.(false);
  };

  const hcf = () => {
    setDOs(null);
    resolver?.(true);
  };

  return (
    <DialogContext.Provider value={{ mG }}>
      {children}
      {dOs && (
        <Dl
            o={!!dOs}
            oc={hc}        
            t={dOs?.t || "Information"}
            tc={dOs?.tc || "black"}
            m={dOs?.m}
            bt={dOs?.bt || "Close"}
            btc={dOs?.btc || "black"}
            bc={dOs?.bc || "white"}
            bch={dOs?.bch || "white"}
            bcf={dOs?.cf ? hcf : undefined}
            bcfc={dOs?.bcfc || "white"}
            bcfh={dOs?.bcfh || "white"}
            bcft={dOs?.bcft || "Confirm"}
        />
      )}
    </DialogContext.Provider>
  );
};
